// extracted by mini-css-extract-plugin
module.exports = {"textStyle":"pol-gen-progress_textStyle__xdh7D","headerClass":"pol-gen-progress_headerClass__HJXZv"};